module.exports = {
  siteMetadata: {
    author: 'FEHRM Communications Team',
    title: `Federal Electronic Health Record Modernization`,
    description: `The Federal Electronic Health Record Modernization (FEHRM) program office works within the federal space to implement a single, common federal electronic health record (EHR) that enhances patient care and provider effectiveness.`,
    image: '/images/fehrm-icon.png',
    siteUrl: 'https://www.fehrm.gov',
    basePath: '',

    /**
     * Search.gov configuration
     * 
     * 1. Create an account with Search.gov https://search.usa.gov/signup
     * 2. Add a new site.
     * 3. Add your site/affiliate name here.
     */
    searchgov: {
      
      // Only change this if you're using a CNAME. Learn more here: https://search.gov/manual/cname.html
      endpoint: 'https://search.usa.gov',
      
      // replace this with your search.gov account
      affiliate: 'fehrm',
      
      // Replace this with your access key.
      access_key: 'jlaqUV_gwFNKeVL4IewKJ7R3iQSJmdOJkZGmc8s082I=',
      
      // This renders the results within the page instead of sending to user to search.gov.
      inline: false, 
      
      // This allows Search.gov to present relevant type-ahead search suggestions in your website's search box. 
      // If you do not want to present search suggestions, set this value to false.
      suggestions: true,
    },

    /**
     * Digital Analytics Program (DAP) configuration
     * 
     * USAID   - Agency for International Development
     * USDA    - Department of Agriculture
     * DOC     - Department of Commerce
     * DOD     - Department of Defense
     * ED      - Department of Education
     * DOE     - Department of Energy
     * HHS     - Department of Health and Human Services
     * DHS     - Department of Homeland Security
     * HUD     - Department of Housing and Urban Development
     * DOJ     - Department of Justice
     * DOL     - Department of Labor
     * DOS     - Department of State
     * DOI     - Department of the Interior
     * TREAS   - Department of the Treasury
     * DOT     - Department of Transportation
     * VA      - Department of Veterans Affairs
     * EPA     - Environmental Protection Agency
     * EOP     - Executive Office of the President
     * GSA     - General Services Administration
     * NASA    - National Aeronautics and Space Administration
     * NARA    - National Archives and Records Administration
     * NSF     - National Science Foundation
     * NRC     - Nuclear Regulatory Commission
     * OPM     - Office of Personnel Management
     * USPS    - Postal Service
     * SBA     - Small Business Administration
     * SSA     - Social Security Administration
     */
    dap: {
      // agency: 'fehrm',

      // Optional
      // subagency: 'your-subagency',
    },

    /**
     * Google Analytics configuration
     */
    ga: {
      // ua: 'your-ua',
    },
  },
  pathPrefix: process.env.BASEURL || '/',
  trailingSlash: 'always',
  plugins: [
    {
      resolve: 'gatsby-plugin-sass',
      options: {
        cssLoaderOptions: {
          esModule: false,
          modules: {
            namedExport: false,
          },
        },
        sassOptions: {
          includePaths: [
            "./node_modules/@uswds",
            "./node_modules/@uswds/uswds/packages",
          ]
        },
      },
    },
    `gatsby-plugin-react-helmet`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `blog-posts`,
        path: `${__dirname}/src/blog-posts`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `content-pages`,
        path: `${__dirname}/src/content-pages`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `content-components`,
        path: `${__dirname}/src/content-components`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `list-pages`,
        path: `${__dirname}/src/list-pages`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `faq-pages`,
        path: `${__dirname}/src/faq-pages`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `multi-faq-pages`,
        path: `${__dirname}/src/multi-faq-pages`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `card-pages`,
        path: `${__dirname}/src/card-pages`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `survey-pages`,
        path: `${__dirname}/src/survey-pages`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `homepage`,
        path: `${__dirname}/src/homepage`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `news-pages`,
        path: `${__dirname}/src/news-pages`,
      },
    },
    `gatsby-transformer-remark`,
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: `gatsby-starter-default`,
        short_name: `starter`,
        start_url: `/`,
        background_color: `#663399`,
        theme_color: `#663399`,
        display: `minimal-ui`,
        icon: `src/images/fehrm-icon.png`, // This path is relative to the root of the site.
      },
    },
    `gatsby-plugin-sitemap`,
    {
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        resolveEnv: () => process.env.GATSBY_ENV,
        env: {
          development: {
            policy: [{ userAgent: '*', disallow: ['/'] }]
          },
          production: {
            policy: [{ userAgent: '*', allow: '/' }]
          }
        }
      }
    },
    // this (optional) plugin enables Progressive Web App + Offline functionality
    // To learn more, visit: https://gatsby.dev/offline
    // `gatsby-plugin-offline`,
  ],
};
